import React from 'react';
export function Footer() {
  return <footer className="w-full bg-pine" data-id="element-105" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-106" data-mp="3gezcj1s77n03">
        <h3 className="font-display text-2xl text-ember" data-id="element-107" data-mp="3ggka709t7m26">Vivencia Ready</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-paper/70" data-id="element-108" data-mp="32p5lqdx4usnq">
          The Rise-Deepen-Return Map — open the plan, pick your music, hold
          the group.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-paper/70" data-id="element-109" data-mp="3uesczotj1hl9">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-paper hover:underline" data-id="element-110" data-mp="37o5ytxdtvcu">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-paper hover:underline" data-id="element-111" data-mp="3le2j4qntu1a6">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-paper hover:underline" data-id="element-112" data-mp="3qf9q4ni5awfs">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-paper/15 pt-5 text-xs leading-relaxed text-paper/50" data-id="element-113" data-mp="2eyt7ymf7i1p8">
          Independent resource. Not affiliated with or endorsed by any school,
          federation or dance method. Vivencia Ready is planning material for
          trained facilitators of adult movement and dance groups; it does not
          replace your training or supervision. It is not therapy or a health
          program: contact is always optional, and participants with injuries,
          pregnancy or other health concerns should use the gentle versions and
          consult their own health professional. &copy; Vivencia Ready 2026 —
          All rights reserved.
        </p>
      </div>
    </footer>;
}